/**
 * @copyright valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperTrbo = {
    /**
     * Check if Trbo is initialized
     *
     * @returns {boolean}
     */
    isTrboInitialized() {
        return typeof window._trbo !== 'undefined' && window._trbo !== null
    }
}

export default liveSearchHelperTrbo
